export default __webpack_public_path__ + "static/media/desktop.a5368682.mp4";